import cn from 'bem-cn';

import { Skeleton, Stack } from '../../UI';
import { PromptInfoStatisticsProps } from './PromptInfoStatistics.types';
import './PromptInfoStatistics.scss';

const b = cn('prompt-info-statistics');

export const PromptInfoStatisticsSkeleton = (props: Pick<PromptInfoStatisticsProps, 'className'>) => {
    const { className } = props;

    return (
        <Stack className={b.mix(className)}>
            <Skeleton className="back-button" variant="circular" width={56} height={56} />
            <Skeleton variant="circular" width={56} height={56} />
            {/* <Divider orientation="vertical" />
            <Skeleton variant="circular" width={56} height={56} /> */}
        </Stack>
    );
};
